export class MyMessage {
    public fromUserName:""
    public toUserName:""
    public datecreated:Date
    constructor(
      public toUser: number,
      public title: string,
      public body: string,
      public fromUserId: number
      
    ) {  }
  
  }